// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 792) return "main.css";
	// return url for filenames based on template
	return "" + ({"54":"SocialFeed","789":"Calendar"}[chunkId] || chunkId) + "-" + {"54":"ad230ac6562fb8b939ec","595":"b7d7f0c80b0f0557e17b","789":"e559e55cba3d4a89c344"}[chunkId] + ".css";
};